<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Create contact list</h3>
    </template>

    <template #default="modalProps">
      <ContactListForm :submit-action="submitAction" @cancel="modalProps.close" />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import ContactListForm from '@/components/ContactLists/Form.vue';

export default {
  components: {
    ContactListForm,
  },

  props: {
    projectUuid: { type: String, required: true },
  },

  methods: {
    ...mapActions('ui/projectContactLists', {
      storeContactList: 'store',
    }),
    submitAction(formData) {
      const { projectUuid } = this;

      return this.storeContactList({ projectUuid, formData })
        .then((response) => {
          this.$refs.modal.doClose();
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
